import { z } from "zod";

/** ISO 4217 currency codes we price in. */
export const currencySchema = z.enum(["USD", "EUR", "TRY"]);
export type Currency = z.infer<typeof currencySchema>;

/** Money is always integer minor units (cents, kuruş) to avoid float drift. */
export const moneySchema = z.object({
  amountMinor: z.number().int().nonnegative(),
  currency: currencySchema,
});
export type Money = z.infer<typeof moneySchema>;

export const localeSchema = z.enum(["en", "tr"]);
export type Locale = z.infer<typeof localeSchema>;

export const idSchema = z.uuid();

export const paginationQuerySchema = z.object({
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(200).default(50),
});
export type PaginationQuery = z.infer<typeof paginationQuerySchema>;

export const apiErrorSchema = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
    details: z.record(z.string(), z.unknown()).optional(),
  }),
});
export type ApiError = z.infer<typeof apiErrorSchema>;
